import styled from 'src/styles/theme';
import { ModalFeaturesStyled } from '../ModalFeaturesStyled';
import { rem } from 'polished';

export const ModalFeaturesStyledAC = styled(ModalFeaturesStyled)`
    .engines,
    .colors,
    .interiors,
    .features {
        .label {
            font-size: ${({ theme }) => theme.fontSizes.h5};
        }
    }

    .categories {
        span {
            background: ${({ theme }) => theme.colors.secondaryHover};
            border-radius: ${rem(24)};
            border-color: ${({ theme }) => theme.colors.blue2};
            color: ${({ theme }) => theme.colors.blue2};
            font-size: ${({ theme }) => theme.fontSizes.textBase};

            &:hover,
            &:focus-visible {
                background: ${({ theme }) => theme.colors.grey5};
                border-color: ${({ theme }) => theme.colors.grey5};
                color: ${({ theme }) => theme.colors.white};
            }
        }
    }
`;
